/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import classNameBind from 'classnames/bind';
import get from 'lodash/get';
import has from 'lodash/has';
import PopoverSection from './components/PopoverSection';
import styles from './Popover.module.css';
import PopoverWrapping from './components/PopoverWrapping/PopoverWrapping';
import PopoverInner from './components/PopoverInner/PopoverInner';

const bindClasses = classNameBind.bind(styles);

class Popover extends React.Component {
  popoverInnerRef = React.createRef();

  static defaultProps = {
    openClass: '',
    position: 'bottom-start',
    autoFocus: false,
    isOpen: false,
    disabled: false,
    onToggle: () => {},
    onBlur: () => {},
    childToggle: null,
    speechBubble: false,
    subdued: false,
    hoverTrigger: false,
    hoverEnable: false,
    clickTrigger: false,
    submenu: false,
    noPadding: false,
    openProps: null,
    closedProps: null,
    fixedWidth: false,
    customMaxWidth: 0,
    minWidth: false,
    onKeyDown: () => {},
    focusOrder: ['reference'],
    dataId: 'Popover',
    disableFocusStyle: false,
    padding: 'small',
  }

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.activatorsParentRef = React.createRef();
  }

  componentDidMount() {
    const { autoFocus } = this.props;

    if (autoFocus) {
      this.activatorElementRef.parentElement.focus();
    }
  }

  onToggle = () => {
    if (this.popoverInnerRef.current) {
      if (this.state.isOpen) {
        this.popoverInnerRef.current.props.close();
      } else {
        this.popoverInnerRef.current.props.open();
      }
    }
  }

  prepareRefElement = (refElem) => {
    const { openProps, closedProps } = this.props;
    const { isOpen } = this.state;
    let newProps = {};
    if (this.hasRef(refElem)) {
      newProps.ref = this.getRef;
    } else {
      newProps.setRef = this.getRef;
    }
    if (openProps || closedProps) {
      if (openProps && isOpen) {
        newProps = { ...openProps, ...newProps };
      }
      newProps = { ...closedProps, ...newProps };
    }

    return React.cloneElement(refElem, newProps);
  };

  getRef = (node) => { this.activatorElementRef = node; };

  hasRef = Component => (
    typeof get(Component, 'type') === 'string' || has(Component, 'refs')
  );

  render() {
    const {
      activatorElement,
      childToggle,
      openClass,
      dataId,
      onKeyDown,
      disabled,
      disableFocusStyle,
    } = this.props;

    const {
      isOpen,
    } = this.state;

    return (
      <PopoverWrapping
        {...this.props}
        data-ppuc-id="Popover"
        insideModal={!!this.activatorsParentRef?.current?.closest('[class*="ModalView"]')}
        onOpen={() => {
          this.setState({ isOpen: true });
          if (typeof this.props.onOpen === 'function') {
            this.props.onOpen();
          }
        }}
        onClose={() => {
          this.setState({ isOpen: false });
          if (this.props.onClose) {
            this.props.onClose();
          }
        }}
        onKeyDown={!disabled ? event => onKeyDown(event, this.onToggle, isOpen) : undefined}
        render={({ close, open }) => (
          <PopoverInner
            close={close}
            open={open}
            childToggle={childToggle}
            ref={this.popoverInnerRef}
            isOpen={this.state.isOpen}
            onToggle={this.onToggle}
          >
            {typeof this.props.children === 'function'
              ? this.props.children(close)
              : this.props.children}
          </PopoverInner>
        )}
      >
        <div
          onClick={e => e.stopPropagation()}
          className={bindClasses('popover-button', isOpen ? openClass : '', { disableFocusStyle })}
          data-ppuc-id={`${dataId}.button`}
          tabIndex={disabled ? -1 : 0}
          onKeyDown={!disabled ? event => onKeyDown(event, this.onToggle, isOpen) : undefined}
          ref={this.activatorsParentRef}
        >
          {this.prepareRefElement(activatorElement)}
        </div>
      </PopoverWrapping>
    );
  }
}

Popover.Section = PopoverSection;

export default Popover;
